import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './i18n';
import './fonts/styles.css';
// CSS de banderas se carga desde index.html (CDN) - eliminado import duplicado

const container = document.getElementById('pagos-app-root');
if (!container) {
  throw new Error('Failed to find the root element');
}

const root = createRoot(container);
root.render(<App />);